export var AUX_DATA_SELECTOR;
!function(AUX_DATA_SELECTOR) {
    AUX_DATA_SELECTOR[AUX_DATA_SELECTOR.NADA = 0] = "NADA", AUX_DATA_SELECTOR[AUX_DATA_SELECTOR.OPEN_LOAN = 1] = "OPEN_LOAN", AUX_DATA_SELECTOR[AUX_DATA_SELECTOR.CLOSE_LOAN = 2] = "CLOSE_LOAN", AUX_DATA_SELECTOR[AUX_DATA_SELECTOR.OPEN_LP = 3] = "OPEN_LP", AUX_DATA_SELECTOR[AUX_DATA_SELECTOR.CLOSE_LP = 4] = "CLOSE_LP";
}(AUX_DATA_SELECTOR || (AUX_DATA_SELECTOR = {}));
